import React from 'react';
import PropType from 'prop-types';
import './WelcomeTooltip.css';
import DragToRotateTooltip from '../DragToRotateTooltip/DragToRotateTooltip';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { singaporeStoreId } from '../../../../utils/StoreConfigManager';
import { WelcomePopupButtonClicked } from '../../../../utils/Analytics';

const browseImg = 'https://cdn.obsess-vr.com/drag-tooltip-desktop.gif';
const productImg = 'https://cdn.obsess-vr.com/drag-tooltip-mobile.gif';
const productHotspotImg = "https://cdn.obsess-vr.com/fendi/fendi_final product_hotspot.svg";
const discoverImg = 'https://cdn.obsess-vr.com/fendi/video_icon.svg';
const isMobile = isMobileDevice();
const desktopTooltip = !isMobile ? {top:'22%'} : {};
const buttonWidth = isMobile ? '240px' : '190px';


const WelcomeTooltip = (props) => {
    const { welcomeMessageStyle, children, showBroseTooltip, showProductTooltip, showBeautyTooltip, isVisible,
        storeId, showMobileTooltip, isMobile, onWelcomeHide } = props;
    const tooltipClass = !isVisible ? 'tooltip-fadeout' : ''

    const onModalHidden = () => {
        onWelcomeHide();
    }

    return (
        <div id="tooltip-container" className={tooltipClass} /* style={desktopTooltip} */ >
            <div id="tooltip-component-container" className="flex-center">
                <div className="tooltip-row">
                    <div className={"tooltip-col fadeInTooltip " + (storeId === singaporeStoreId && 'singapore-store')}>
                        <h3>BROWSE</h3>
                        <span className="tooltip-message">
                            Click and drag the screen or use the arrows on the floor to explore.
                        </span>
                        <DragToRotateTooltip imgStyle={{ width: '6.5em', height: '6.5em' }} isTemplate image={browseImg} classes={'tooltip-first-img'} />
                    </div>
                    <div className={'tooltip-col ' + (showProductTooltip ? 'fadeInTooltip ' : '') + (storeId === singaporeStoreId && 'singapore-store')}>
                        {showProductTooltip && <><h3>PRODUCT</h3>
                            <span className="tooltip-message">
                            Click on the icon to see product details and add them to your wishlist.
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '6em', height: '6em' }} isTemplate backImg={productHotspotImg} image={productImg} /> </>}
                    </div>
                    <div className={'tooltip-col ' + (showBeautyTooltip ? 'fadeInTooltip ' : '') + (storeId === singaporeStoreId && 'singapore-store')}>
                        {showBeautyTooltip && <><h3>DISCOVER</h3>
                            <span className="tooltip-message">
                                Click on the icon to view exclusive content, tutorials and more!
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '3.5em', height: '3.5em' }} isTemplate image={discoverImg} classes={'star'} /></>}
                    </div>
                </div>
                <Button
                    hoverStyleChange={false}
                    onClick={()=>{ onModalHidden(); WelcomePopupButtonClicked('Explore Now'); } }
                    primaryColor='#f9b949'
                    secondaryColor='#000000'
                    className="product-button flex-center obsessvr-regularFont full-width pointer"
                    style={{ padding: '0', borderRadius: '4px', width: buttonWidth, height: '2em', cursor: 'pointer', pointerEvents: 'all' }}
                    primaryBorderColor={"#f9b949"}
                    secondaryBorderColor={"#000000"}
                    insetBorder={true}
                    padded={false}
                >
                    <span className='obsessvr-regularFont ' style={{color:'#000000',fontWeight: '700', fontSize: '14px'}}>
                        EXPLORE NOW
                    </span>
                </Button>
                {children}
            </div>
        </div>
    );
};

WelcomeTooltip.propTypes = {
    welcomeMessageStyle: PropType.object,
    showBroseTooltip: PropType.bool,
    showBeautyTooltip: PropType.bool,
    showProductTooltip: PropType.bool,
};

export default WelcomeTooltip;
